import { createAction, props } from "@ngrx/store";
import { Params } from "@angular/router";

export const storeRedirectParams = createAction(
	"[Auth] Store Redirect Params",
	props<{ path: string; queryParams: Params }>()
);

export const clearRedirectParams = createAction("[Auth] Clear Redirect Params");
